<template>
  <section class="w-full max-w-2xl mx-auto px-6 py-12 sm:py-16">
    <p class="text-xl sm:text-2xl leading-relaxed mb-8">
      Welcome to Måndagsklubben &mdash; a friendly afterwork community on that
      dreadful of weekdays: <em>Monday</em>
    </p>

    <div class="space-y-6 text-base sm:text-lg leading-relaxed opacity-90">
      <p>
        Our events are self-organized and free to attend and takes place
        downstairs at German Beer Hall Hornstull in Stockholm, Sweden, on
        <em>every</em> Monday evening.
      </p>
      <p>
        Måndagsklubben was started by the programmers Iona Rosin and Oskar
        Duveborn back in 2011. They wanted a place to hang out after work on
        Mondays where both introverts and extroverts could feel both welcome and
        engaged. We've spent four years at KGB Bar and another four years at
        Wokhouse.
      </p>
      <p>
        You'll feel just as home sitting in a corner hacking away on your latest
        project with a coffee or a beverage from the bar as when you're
        participating in the latest big screen or table activity with your
        friends, coworkers, strangers or competitors.
      </p>
      <p>
        People usually arrive between 17:00 and 19:00 and the crowd varies from
        week to week. If there's a special event, it'll be posted here, but fret
        not &mdash; we're here every Monday even if there's nothing special posted!
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",
};
</script>
